export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Kpivalue.vue?vue&type=template&id=7a83d760&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Kpi/Kpivalue.vue?vue&type=template&id=7a83d760&
// module id = null
// module chunks = 